import { render, staticRenderFns } from "./areaPasswordForgotten.vue?vue&type=template&id=24565872&scoped=true"
import script from "./areaPasswordForgotten.vue?vue&type=script&lang=js"
export * from "./areaPasswordForgotten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24565872",
  null
  
)

export default component.exports